
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 8h10v10c0 3.302-2.698 6-6 6v-2c2.22 0 4-1.78 4-4H4V8zm14 0h10v10c0 3.302-2.698 6-6 6v-2c2.22 0 4-1.78 4-4h-8V8zM6 10v6h6v-6H6zm14 0v6h6v-6h-6z"}})])
          )
        }
      }
    